module.exports = __webpack_public_path__ + "media/images/icons/lightbulb-9baaa1d40c761be9ec7dc4bb5a23ddbe.svg";